"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GemunionSupportedChains = void 0;
var GemunionSupportedChains;
(function (GemunionSupportedChains) {
    GemunionSupportedChains[GemunionSupportedChains["GEMUNION"] = 10000] = "GEMUNION";
    GemunionSupportedChains[GemunionSupportedChains["GEMUNION_BESU"] = 10001] = "GEMUNION_BESU";
    GemunionSupportedChains[GemunionSupportedChains["ETHEREUM"] = 1] = "ETHEREUM";
    GemunionSupportedChains[GemunionSupportedChains["ETHEREUM_SEPOLIA"] = 11155111] = "ETHEREUM_SEPOLIA";
    GemunionSupportedChains[GemunionSupportedChains["BINANCE"] = 56] = "BINANCE";
    GemunionSupportedChains[GemunionSupportedChains["BINANCE_TEST"] = 97] = "BINANCE_TEST";
    GemunionSupportedChains[GemunionSupportedChains["POLYGON"] = 137] = "POLYGON";
    GemunionSupportedChains[GemunionSupportedChains["POLYGON_AMOY"] = 80002] = "POLYGON_AMOY";
    GemunionSupportedChains[GemunionSupportedChains["AVALANCHE"] = 43114] = "AVALANCHE";
    GemunionSupportedChains[GemunionSupportedChains["AVALANCHE_FUJI"] = 43113] = "AVALANCHE_FUJI";
    GemunionSupportedChains[GemunionSupportedChains["FANTOM"] = 250] = "FANTOM";
    GemunionSupportedChains[GemunionSupportedChains["FANTOM_TEST"] = 4002] = "FANTOM_TEST";
    GemunionSupportedChains[GemunionSupportedChains["ARBITRUM"] = 42161] = "ARBITRUM";
    GemunionSupportedChains[GemunionSupportedChains["ARBITRUM_SEPOLIA"] = 421614] = "ARBITRUM_SEPOLIA";
    GemunionSupportedChains[GemunionSupportedChains["OPTIMISM"] = 10] = "OPTIMISM";
    GemunionSupportedChains[GemunionSupportedChains["OPTIMISM_SEPOLIA"] = 11155420] = "OPTIMISM_SEPOLIA";
    GemunionSupportedChains[GemunionSupportedChains["IMMUTABLE"] = 13371] = "IMMUTABLE";
    GemunionSupportedChains[GemunionSupportedChains["IMMUTABLE_TEST"] = 13473] = "IMMUTABLE_TEST";
})(GemunionSupportedChains || (exports.GemunionSupportedChains = GemunionSupportedChains = {}));
//# sourceMappingURL=supported.js.map